"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _SES = /*#__PURE__*/ _interop_require_default(require("./SES"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let SESPlugin = class SESPlugin extends _ncplugin.XcEmailPlugin {
    getAdapter() {
        return SESPlugin.storageAdapter;
    }
    async init(config) {
        SESPlugin.storageAdapter = new _SES.default(config);
        await SESPlugin.storageAdapter.init();
    }
};
const _default = SESPlugin;
